import { getOrderRelatedFilmById } from '@vista/omnichannel-components-domain';
import { getFeaturedShowtimeForJourney } from './get-featured-showtime-for-journey';
export function getFeaturedFilmForJourney(journey) {
    const featuredShowtime = getFeaturedShowtimeForJourney(journey);
    if (!featuredShowtime)
        return undefined;
    const film = getOrderRelatedFilmById(featuredShowtime.filmId);
    if (!film)
        throw new Error(`Cannot find film with ID: ${featuredShowtime.filmId}.`);
    return film;
}
